<template>
  <div class="wx-bind">
    <nav-title title='新用户注册'></nav-title>
    <div class="contanier">
      <p class='title'>成为森果云卖家后您即可注册店铺</p>
      <mobile-input
        autofocus
        title='真实姓名'
        placeholder='请输入真实姓名'
        v-model='realname'
        @inputTest="inputLimitNormal($data, 'realname')"
      />
      <div class="button" v-if='!realname.length > 0'>下一步</div>
      <div class="button Cbutton" v-else @click='bindWechatEvent' >下一步</div>
      <div class="read">
        <el-checkbox :value="read" @change="handleReadChange" style="margin-right: 10px;"></el-checkbox>
        <span>我已阅读并同意</span>
        <span style="color: #63A6FF" @click="seeUserAgreement">《用户协议》</span>
        <span>和</span>
        <span style="color: #63A6FF" @click="seePrivacyAgreement">《隐私协议》</span>
      </div>
    </div>
    <div class="footer">
      <span @click="logoutEvent">退出登录</span>
    </div>
  </div>
</template>

<script>
import { inputLimitNormal, initPluginsWithPrivacy } from '@/utils'
import { isAndroid } from '@/assets/js/util'
import { whatApp } from '@/utils'
import { privacyUrl, userUrl } from "@/config/config";

export default {  
  data() {
    return {
      realname: '',
      read: false
    }
  },

  created() {
    this.inputLimitNormal = inputLimitNormal
  },

  methods: {
    bindWechatEvent() {
      if (!this.read) return this.openMessage(0, '请先同意用户协议再注册')

      window.sessionStorage.setItem('realname', this.realname)
      if (isAndroid()) {
        try {
          window.Assistant.getWxLoginCode('bindWxCallback')
        } catch(e) {
          this.openMessage(0, '暂无客户端授权')
        }
      } else {
        if (whatApp('wsc')) return this.openMessage(0, '请前往PC端注册绑定微信和手机号')
        try {
          window.webkit.messageHandlers.NativeApi.postMessage({"func": "getWxLoginCode", "param": "bindWxCallback"})
        } catch {
          this.openMessage(0, '暂无客户端授权')
        }
      }
    },  
    seeUserAgreement() {
      window.location.href = userUrl
    },

    seePrivacyAgreement () {
      window.location.href = privacyUrl
    },
    logoutEvent() {
      if (this.logoutLock) return;
      this.logoutLock = true
      this.$fetch.post({
        url: '/login?method=logout'
      }).finally(() => {
        this.$router.push({path: '/mobileInit'})
         this.logoutLock = false
      })
    },

    handleReadChange(val) {
      this.read = val
      if (val) {
        initPluginsWithPrivacy()
      }
    }
  },
   
}
</script>

<style lang='scss' scoped>
html, body {
  ::-webkit-scrollbar {
      width: 0;
      height: 16px;
      background-color: #F5F5F5;
  }
}

#app {
  width: 100%;
  height: 100%;
}

.wx-bind {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.contanier {
  padding: 0 10px;
  background-color: #fff;

  .title {
    margin-top: 30px;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }

  .button {
    margin-top: 20px;
    width: 100%;
    height: 50px;
    background-color: #ddd;
    color: #ddd;
    font-size: 16px;
    color: #fff;
    border-radius: 5px;
    line-height: 50px;
    text-align: center;
  }

  .Cbutton {
    background-color: #009688;
    
    &:active {
      background-color: rgba(0,134,122,100);
    }
  }
}

.read {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  }

.footer {
  width: 100%;
  position: fixed;
  bottom: 5%;
  left: 0;
  text-align: center;

  span {
    display: inline-block;
    height: 20px;
    width: 56px;
    font-size: 14px;
    line-height: 20px;
    color: #999;
    border-bottom: 1px solid #999;

    &:active {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>